module.exports = __webpack_public_path__ + "static/media/bbq1.38e70dcf.png";